'use client'

import {
  assertSafePaginationToken,
  fetchAllowlistedGraphProxyUrl,
  type AllowedGraphType,
} from './graphProxyParams'

/** Same-origin proxy paths only — avoids dynamic path strings for static SSRF rules. */
const GRAPH_PROXY_PATH: Record<AllowedGraphType, `/api/get-graph/${AllowedGraphType}`> = {
  continuous: '/api/get-graph/continuous',
  pie: '/api/get-graph/pie',
}

/**
 * Reusable client-side data fetcher for all graphs.
 * Calls the local Next.js proxy route.
 */
export async function getGraphData(
  type: AllowedGraphType,
  next?: string,
): Promise<unknown> {
  const pathname = GRAPH_PROXY_PATH[type]
  let url: string = pathname
  if (next !== undefined && next !== '') {
    assertSafePaginationToken(next)
    url = `${pathname}?${new URLSearchParams({ next }).toString()}`
  }

  try {
    const response = await fetchAllowlistedGraphProxyUrl(url)
    if (!response.ok) {
      throw new Error(`Local API proxy failed: ${response.status}`)
    }
    return response.json()
  } catch (error) {
    console.error('getGraphData fetch error:', error)
    throw error // Re-throw to be caught by the component
  }
}
